import SessionStorage from "../app/SessionStorage";

export default class SessionStorageAdapter<T = unknown> implements SessionStorage<T> {

    get(key: string): T {
        try {
            return JSON.parse(window.sessionStorage.getItem(key)) ?? undefined;
        } catch {
            return undefined;
        }
    }

    set(key: string, value: T) {
        window.sessionStorage.setItem(key, JSON.stringify(value));
    }

}
